import React from 'react'

import { RadioButton } from '../baseInputs'

type Props = {
  helper?: string
  optional?: boolean
}

const PartEx = ({ optional, ...rest }: Props) => {
  return (
    <div>
      <p className="font-medium my-5">
        {'Do you have a vehicle to part exchange? '}
        {optional && (
          <span className="text-xs font-normal lowercase whitespace-nowrap">
            (optional)
          </span>
        )}
      </p>
      <div className="radio-btn-container flex mb-5">
        <RadioButton name="part_ex" label="Yes" value={true} {...rest} />
        <RadioButton name="part_ex" label="No" value={false} {...rest} />
      </div>
    </div>
  )
}

export default PartEx
